// extracted by mini-css-extract-plugin
export default {"hero":"Header_hero__8jKtD"};